import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  PaymentChannelModel,
  PaymentChannelMutationInput,
  PaymentChannelDeleteInput,
  PaymentChannelUpdateInput,
} from './model';

export function useCreatePaymentChannel(
  options?: UseMutationOptions<
    ApiResult<PaymentChannelModel>,
    ApiError,
    PaymentChannelMutationInput
  >,
): UseMutationResult<
  ApiResult<PaymentChannelModel>,
  ApiError,
  PaymentChannelMutationInput
> {
  return useMutation<
    ApiResult<PaymentChannelModel>,
    ApiError,
    PaymentChannelMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'payment-channels',
      method: 'POST',
      classType: PaymentChannelModel,
      body,
    });
  }, options);
}

export function useUpdatePaymentChannel(
  options?: UseMutationOptions<
    ApiResult<PaymentChannelModel>,
    ApiError,
    PaymentChannelUpdateInput
  >,
): UseMutationResult<
  ApiResult<PaymentChannelModel>,
  ApiError,
  PaymentChannelUpdateInput
> {
  return useMutation<
    ApiResult<PaymentChannelModel>,
    ApiError,
    PaymentChannelUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `payment-channels/${body.paymentChannelId}`,
      method: 'PUT',
      classType: PaymentChannelModel,
      body: body.body,
    });
  }, options);
}

export function useDeletePaymentChannel(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    PaymentChannelDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, PaymentChannelDeleteInput> {
  return useMutation<{ message: string }, ApiError, PaymentChannelDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `payment-channels/${body.paymentChannelId}`,
        method: 'DELETE',
      });
    },
    options,
  );
}
